const formatDuration = (duration) => {
  const hour = Math.floor(duration / 60);
  const minutes = duration % 60;
  return `${hour > 0 ? `${hour}h` : ''} ${minutes > 0 ? `${minutes}m` : ''}`.trim();
};

export default formatDuration;
